import { useQuery } from '@tanstack/react-query';
import type { PaginatedList } from '../../models/common/paginated-list.model';
import type { MyEvaluationPlansDto } from '../../models/evaluation-plans/evaluation-plans.dto';
import apiRequest from '../../services/apiWrapper';
import { createPaginatedQueryKeys } from '../../services/createPaginatedQueryKeys';
import { EVALUATION_PLANS_URL } from '../../utils/constants/urlConstants';

async function fetchMyEvaluationPlans(searchParams: URLSearchParams) {
  const response = await apiRequest.get<PaginatedList<MyEvaluationPlansDto>>(
    `${EVALUATION_PLANS_URL}/created-plans?${searchParams.toString()}`
  );

  return response.data;
}

export function usePaginatedMyEvaluationPlans(searchParams: URLSearchParams) {
  return useQuery({
    queryKey: ['my-evaluation-plans', createPaginatedQueryKeys(searchParams)],
    queryFn: () => fetchMyEvaluationPlans(searchParams),
  });
}
